import { LazyRoute } from '@app/components/lazy-route';
import { PusherProviderWrapper } from '@app/components/pusher-provider';
import React, { lazy } from 'react';

const EditorPage = lazy(() => import('./editor-page'));

const Editor = () => {
  return (
    <LazyRoute>
      <PusherProviderWrapper>
        <EditorPage />
      </PusherProviderWrapper>
    </LazyRoute>
  );
};

export { Editor };
